'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _RailLogoCarrierNumber = require('./RailLogoCarrierNumber');

var _RailLogoCarrierNumber2 = _interopRequireDefault(_RailLogoCarrierNumber);

var _RailCardJourneyInfo = require('./RailCardJourneyInfo');

var _RailCardJourneyInfo2 = _interopRequireDefault(_RailCardJourneyInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RailCardJourney(props) {
  var components = props.components,
      logo = props.logo,
      journey = props.journey,
      validFrom = props.validFrom,
      validTo = props.validTo,
      t = props.t;


  var styleRailCardContainer = {
    backgroundColor: components.RailCardContainer.backgroundColor
  };

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'TransportationDetails' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleRailCardContainer, { padding: '10px' }) },
          _react2.default.createElement(
            'table',
            { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'TransportationDetails_Sub' },
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { style: { paddingTop: '0', paddingRight: '10px', paddingBottom: '0', paddingLeft: '0', verticalAlign: 'top', width: '20%' } },
                  _react2.default.createElement(_RailLogoCarrierNumber2.default, {
                    logo: {},
                    carrierCode: logo.vendorCode,
                    carrierName: logo.vendorName
                  })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(_RailCardJourneyInfo2.default, {
                    label: '' + t('rail.fromZone'),
                    country: journey.origin.fromCountry,
                    time: validFrom,
                    titleLabelStyle: components.FromZoneLabel,
                    titleValueStyle: components.ValidFromDate
                  })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(_RailCardJourneyInfo2.default, {
                    label: '' + t('rail.toZone'),
                    country: journey.destination.toCountry,
                    time: validTo,
                    titleLabelStyle: components.ToZoneLabel,
                    titleValueStyle: components.ValidToDate
                  })
                )
              )
            )
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactI18next.translate)()((0, _reactRedux.connect)(mstp)(RailCardJourney));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/RailCard/Email/RailCardJourney.jsx
// module id = 1546
// module chunks = 0